import React, {useState, useEffect} from 'react';
import {toJS} from 'mobx';

import {Form, Row, Col, Input, Button, Select} from 'antd';
import store from "./store";
import {observer} from 'mobx-react';
import lodash from "lodash";

import district from "../district"

import styles from '../layout.module.less'

// the hook
import { useTranslation } from 'react-i18next';

export default observer(function (props) {
  const { t } = useTranslation();
  const formRef = React.createRef();
  const provinceRef = React.createRef();
  const cityRef = React.createRef();
  const areaRef = React.createRef();

  const address = toJS(store.address)

  const [province, setProvince] = useState({label: '', value: 0})
  const [city, setCity] = useState({label: '', value: 0})
  const [area, setArea] = useState({label: '', value: 0})
  const [provinceOpen, setProvinceOpen] = useState(false)
  const [cityOpen, setCityOpen] = useState(false)
  const [areaOpen, setAreaOpen] = useState(false)


  const [loading, setLoading] = useState(false)

  useEffect(() => {
    let provinceCode = getCodeByName(address.province, district[100000])
    let cityCode = getCodeByName(address.city, district[provinceCode])
    let areaCode = getCodeByName(address.city, district[cityCode])

    setProvince({label: address.province + '', value: provinceCode})
    setCity({label: address.city + '', value: cityCode})
    setArea({label: address.area + '', value: areaCode})

    address.province = province.value
    address.city = province.city
    address.area = province.area

  }, [])

  const layout = {
    labelCol: {span: 8},
    wrapperCol: {span: 14}
  }

  const oneLine = {
    labelCol: {span: 4},
    wrapperCol: {span: 19},
  }

  const onFinish = values => {
    values.province = province.label
    values.city = city.label
    values.area = area.label
    setLoading(true)

    store.updateAddress(values).then(() => {
      props.setVisible()
    }).finally(() => {
      setLoading(false)
    })


  }

  const getCodeByName = (name, data) => {
    let code = 0
    lodash.forEach(data, function (value, key) {
      if (value === name) {
        code = key
      }
    })

    return code
  }


  // 选择 省
  const onProvinceChange = (value, option) => {
    setProvince(option)
    setCity({label: '', value: 0})
    setArea({label: '', value: 0})
    setCityOpen(true)
    address.province = option.value
    address.city = 0
    address.area = 0

    formRef.current.setFieldsValue({
      city: '',
      area: '',
    });

    provinceRef.current.blur()
    cityRef.current.focus()
  }

  // 选择 市
  const onCityChange = (value, option) => {
    setCity(option)
    setArea({label: '', value: 0})
    setCityOpen(false)
    setAreaOpen(true)
    address.city = option.value
    address.area = 0

    formRef.current.setFieldsValue({
      area: '',
    });
    cityRef.current.blur()
    areaRef.current.focus()
  }

  // 选择 区
  const onAreaChange = (value, option) => {
    setArea(option)
    setAreaOpen(false)
    address.area = option.value
    areaRef.current.blur()
  }

  const renderOption = (data, cur) => {
    let options = []
    lodash.forEach(district[data], (value, index) =>
      options.push({
        label: value,
        value: index
      })
    )
    return options
  }

  return (
    <React.Fragment>

      <div className={styles.formModalContent}>
        <div className={styles.formBox}>


          <Form
            {...layout}
            ref={formRef}
            name="basic"
            className={styles.form}
            initialValues={address}
            validateTrigger='onBlur'
            onFinish={onFinish}
          >
            <Row gutter={24}>
              <Col span={12} style={{paddingLeft: '0.0938rem'}}>
                <Form.Item
                  label={t('收货人姓名')}
                  name="name"
                  rules={[{required: true, message:  t('请输入')+'!'}]}
                >
                  <Input/>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label={t('手机')}
                  name="phone"
                  rules={[
                    {required: true, message:  t('请输入')+'!'},
                    {pattern: /^[1]([3-9])[0-9]{9}$/, message: t('请输入正确的手机号码')}
                  ]}
                >
                  <Input/>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col span={12} style={{paddingLeft: '0.0938rem'}}>

                <Form.Item
                  label={t('邮政编码')}
                  name="post"
                  rules={[
                    {required: true, message: t('请输入')+'!'},
                    {pattern: /^\d{6}$/, message: t('请输入正确的邮政编码')}
                  ]}
                >
                  <Input/>
                </Form.Item>

              </Col>
              <Col span={12}>
                <Form.Item
                  label={t('备注')}
                  name="remark"
                >
                  <Input/>
                </Form.Item>

              </Col>
            </Row>


            <div className='flex'>

              <Form.Item
                label={t('配送地址')}
                name="province"
                labelCol={{span: 9}}
                rules={[{required: true, message: t('请选择')}]}
                style={{flex: 1}}
              >
                <Select
                  ref={provinceRef}
                  style={{width: '0.9375rem', marginRight: '0.0781rem'}}
                  options={renderOption(100000)}
                  onChange={onProvinceChange}
                  placeholder={t('请选择')}
                  getPopupContainer={triggerNode => triggerNode.parentElement}
                />
              </Form.Item>
              <Form.Item
                name="city"
                rules={[{required: true, message: t('请选择')}]}
              >
                <Select
                  ref={cityRef}
                  style={{width: '0.9375rem', marginRight: '0.0781rem'}}
                  options={renderOption(province.value)}
                  open={cityOpen}
                  onFocus={v => setCityOpen(true)}
                  onBlur={v => setCityOpen(false)}
                  onChange={onCityChange}
                  placeholder={t('请选择')}
                  getPopupContainer={triggerNode => triggerNode.parentElement}
                />
              </Form.Item>
              <Form.Item
                name="area"
                rules={[{required: true, message: t('请选择')}]}
              >
                <Select
                  ref={areaRef}
                  style={{width: '0.9115rem', marginRight: '0.1563rem'}}
                  options={renderOption(city.value)}
                  open={areaOpen}
                  onFocus={v => setAreaOpen(true)}
                  onBlur={v => setAreaOpen(false)}
                  onChange={onAreaChange}
                  placeholder={t('请选择')}
                  getPopupContainer={triggerNode => triggerNode.parentElement}
                />
              </Form.Item>

            </div>


            <Form.Item
              {...oneLine}
              label={t('详细地址')}
              name="details"
              rules={[{required: true, message: t('请输入')+'!'}]}
            >
              <Input/>
            </Form.Item>


            {/*隐藏元素*/}
            <Form.Item
              name="id"
              hidden={true}
            >
              <Input/>
            </Form.Item>
            <Form.Item
              name="is_default"
              hidden={true}
            >
              <Input/>
            </Form.Item>
            <Form.Item
              name="is_del"
              hidden={true}
            >
              <Input/>
            </Form.Item>
            <Form.Item
              name="customer_id"
              hidden={true}
            >
              <Input/>
            </Form.Item>


            <div style={{padding: '0.0521rem 0.2708rem 0.1042rem'}}>{t('标记')}“<a>*</a>”{t('的为必填项')}</div>

            <div style={{textAlign: 'center'}}>
              <Button type="primary" htmlType="submit" size='large' loading={loading}>{t('保存')}</Button>
            </div>
          </Form>

        </div>

      </div>

    </React.Fragment>
  )
})
